export default __webpack_public_path__ + "static/media/undraw_services_5tv9.9c72994e.svg";